"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _FoldersAndFiles = require("FileManagerCore/utils/FoldersAndFiles");

var _FolderTreeContainer = _interopRequireDefault(require("FileManagerCore/containers/FolderTreeContainer"));

var _ScopedFeatureTooltip = _interopRequireDefault(require("FileManagerCore/components/permissions/ScopedFeatureTooltip"));

var MoveButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(MoveButton, _Component);

  function MoveButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, MoveButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MoveButton).call(this, props));
    _this.state = {
      open: false,
      selectedFolder: null
    };
    _this.handleSelect = _this.handleSelect.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleMove = _this.handleMove.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOpenChange = _this.handleOpenChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClickMove = _this.handleClickMove.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(MoveButton, [{
    key: "getSelectedFolder",
    value: function getSelectedFolder() {
      return this.state.selectedFolder || this.props.folder;
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(folder) {
      this.setState({
        selectedFolder: folder || (0, _FoldersAndFiles.getHomeFolder)()
      });
    }
  }, {
    key: "handleMove",
    value: function handleMove() {
      var onMove = this.props.onMove;
      var selectedFolder = this.state.selectedFolder;
      onMove(selectedFolder);
      this.setState({
        open: false,
        selectedFolder: null
      });
    }
  }, {
    key: "handleOpenChange",
    value: function handleOpenChange() {
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        open: false
      });
    }
  }, {
    key: "handleClickMove",
    value: function handleClickMove() {
      this.setState({
        open: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          use = _this$props.use,
          size = _this$props.size,
          isReadOnly = _this$props.isReadOnly;
      var _this$state = this.state,
          open = _this$state.open,
          selectedFolder = _this$state.selectedFolder;
      return _react.default.createElement(_UIPopover.default, {
        open: open,
        closeOnOutsideClick: true,
        onOpenChange: this.handleOpenChange,
        placement: "top",
        content: {
          header: _react.default.createElement("h5", null, _I18n.default.text('FileManagerLib.selectFolder')),
          body: _react.default.createElement("div", {
            className: "move-button__folder-tree"
          }, _react.default.createElement(_FolderTreeContainer.default, {
            selectedFolder: this.getSelectedFolder(),
            onSelect: this.handleSelect
          })),
          footer: _react.default.createElement("div", null, _react.default.createElement(_UIButton.default, {
            use: "tertiary",
            size: "small",
            disabled: !selectedFolder,
            onClick: this.handleMove
          }, _I18n.default.text('FileManagerCore.actions.save')), _react.default.createElement(_UIButton.default, {
            use: "link",
            size: "small",
            onClick: this.handleClose
          }, _I18n.default.text('FileManagerCore.actions.cancel')))
        }
      }, _react.default.createElement(_ScopedFeatureTooltip.default, null, _react.default.createElement(_UIButton.default, {
        use: use,
        size: size,
        disabled: isReadOnly,
        "data-test-id": "move-button",
        onClick: this.handleClickMove
      }, _I18n.default.text('FileManagerCore.actions.move'))));
    }
  }]);
  return MoveButton;
}(_react.Component);

exports.default = MoveButton;
MoveButton.propTypes = {
  folder: _propTypes.default.instanceOf(_immutable.default.Map),
  size: _UIButton.default.propTypes.size,
  use: _UIButton.default.propTypes.use,
  onMove: _propTypes.default.func.isRequired,
  isReadOnly: _propTypes.default.bool.isRequired
};
MoveButton.defaultProps = {
  use: 'tertiary-light',
  size: 'small'
};
module.exports = exports.default;